import React from "react";
import classNames from "classnames";
import { IconProps, IconDimensions } from "../../types";
import { getIconDimensions } from "../../../utils/icon-utils";

export const IconCheckCircledCheckedFilled = ({
  title,
  titleId,
  color,
  className: classNameProp,
  size,
  height,
  width,
  ...restProps
}: IconProps) => {
  const className = classNames(
    {
      [`text-${color}`]: color !== undefined,
    },
    classNameProp
  );

  const defaultDimensions: IconDimensions = {
    height: 24,
    width: 24,
  };
  const props = {
    className,
    ...getIconDimensions(size, width, height, defaultDimensions?.width, defaultDimensions?.height),
    ...restProps,
  };

  return (
    <svg fill="currentcolor" viewBox="0 0 24 24" {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        d="M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1 1 5.925 1 12Zm8.796 1.922L15.91 7.68a.6.6 0 01.859.001l.558.573a.6.6 0 01-.001.839l-7.09 7.237a.6.6 0 01-.852.005L6.42 13.412a.6.6 0 01.006-.856L7 12a.6.6 0 01.841.006l1.955 1.915Z"
      />
    </svg>
  );
};

IconCheckCircledCheckedFilled.displayName = "IconCheckCircledCheckedFilled";
